export default __webpack_public_path__ + "static/media/manageDocs.330d30f9.png";